import styled from "styled-components";

interface JackpotBetWinHighlightLabelDefaultBoxProps {
    fontSize?: string;
}
export const JackpotBetWinHighlightLabelDefaultBox = styled.div<JackpotBetWinHighlightLabelDefaultBoxProps>`
    font-weight: 700;
    font-size: ${({fontSize}) => fontSize || "2.4rem"};
    color: #fff;
    text-align: center;
    text-transform: uppercase;
    text-wrap: nowrap;
`;


